import { Component, OnInit, Input,Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { MatSnackBar } from '@angular/material';
import { TextSearch } from '../../../../comum/textSearch';
import { Localidades } from '../../../../models/localidades.model';
import { AngularFirestore } from 'angularfire2/firestore';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
    selector: 'regiao-control',
    template: `
    <div fxLayout="column"> 
      <div><b>Região que atende</b><div>
      <div>
      <mat-list>
        <mat-list-item *ngFor="let item of lista">
          {{item}} <button mat-button (click)="remover(item)"> remover </button>
        </mat-list-item>
      </mat-list>
      </div>
      <div fxLayout="row">
      <mat-form-field>
        <mat-select [(value)]="selected" placeholder="Regiões">
           <mat-option *ngFor="let item of regioes" [value]="formataNome(item)">
             {{formataNome(item)}}
          </mat-option>
        </mat-select>
     </mat-form-field>
      <button mat-button (click)="adicionar(selected)">adicionar</button>
     </div>
     </div>   
    `,
    styles: [``]
})
export class RegiaoControl implements OnInit {
    lista: any[] = [];
    fRegiao = {};
    regioes : any[]=[];
    @Input()
    set regiao(x:any) {
        this.fRegiao = x;
        console.log('regiao',x);
        this.lista = [];
        if (x){
         for(let key of Object.keys(x)) {
            this.lista.push(key);
          };
        }    
    }

    @Output()
    change =  new EventEmitter();

    constructor(public snackBar: MatSnackBar,
      private db:AngularFirestore) { }

    ngOnInit(): void {
         new Localidades(this.db).snapshot(null,(d)=>{
           this.regioes = [];
           d.forEach(element => {
               console.log(element);
               this.regioes.push(element);
           });
         });


     }


    formataNome(item){
      if (item.nome.indexOf('-'+item.estado)<0)
         return item.nome+'-'+item.estado;
      else 
         return item.nome   
    } 
    remover(item){
      if (this.lista.length>=1){
       let i = this.lista.indexOf(item);
       if (i>=0){
           this.lista.splice(i,1);
       }
        this.change.emit(this.lista);
        console.log('onChange:',this.lista);
    } else {
          this.snackBar.open('ups... se remover todos não ira aparecer em nenhuma região',
         null, {duration:2000}
        );
      }
       
    }
  
   adicionar(item){
       if (item && item.length>3)
       {
          console.log('Regiao:',item);
          let x = TextSearch.toFieldNameFormat(item); 
          if (this.lista.indexOf(x)<0)
             this.lista.push(x);
          this.change.emit(this.lista);
       }
   } 




}
